import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import { RouterProvider } from 'react-router-dom';
import { UserContextProvider } from './context';
import Layout from './components/Layout';
import Home from './components/Home';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
]);

function App() {
  return (
    <UserContextProvider>
      <RouterProvider router={router} />
    </UserContextProvider>
  );
}

export default App;